module.exports = __webpack_public_path__ + "img/reports.9b0a7342.svg";